const projectReducer = (state = {
    loading:false,
    project:null
}, action) => {
    switch (action.type) {
        case "FETCH_PROJECT":
            return { ...state ,loading:true}
        case "RECEIVE_PROJECT":
            return {...state, project:action.payload,loading:false,}
        case "ERROR_PROJECT":
            return { ...state ,loading:true}
        default:
            return { ...state }
    }
}

export default projectReducer;